export interface CreateScriptOptions {
  url: string;
  onLoad: () => void;
  id?: string;
  defer?: boolean;
  async?: boolean;
  onError?: (message: string) => void;
}

export const createScript = ({ url, id, defer, async, onLoad, onError }: CreateScriptOptions) => {
  const script = document.createElement('script');

  script.src = url;
  document.body.appendChild(script);

  if (id) {
    script.id = id;
  }

  if (defer) {
    script.defer = defer;
  }

  if (async) {
    script.async = async;
  }

  if (onError) {
    // eslint-disable-next-line max-params
    script.onerror = (message, errorUrl, line, col, errorObj) => {
      const errorString = errorObj
        ? errorObj.message
        : typeof message === 'string'
          ? message
          : 'Unknown error';

      onError(`Failed to load ${url}: ${errorString}`);
    };
  }

  script.onload = onLoad;

  return script;
};
